import * as React from 'react'

const SvgPlayingGameIcon = (props) => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.00028 6.16669H7.33361M5.66694 4.50002V7.83335M11.5003 7.00002H11.5086M14.0003 5.33335H14.0086M7.70774 1.16669H10.2928C12.4802 1.16669 13.5739 1.16669 14.4324 1.58121C15.1882 1.94619 15.8162 2.53093 16.2341 3.25885C16.7088 4.0856 16.7867 5.17653 16.9425 7.35837L17.1476 10.2288C17.2481 11.6362 16.1334 12.8334 14.7224 12.8334C14.0008 12.8334 13.3165 12.5128 12.8546 11.9585L12.5419 11.5834C12.256 11.2402 12.113 11.0686 11.9502 10.93C11.6089 10.6393 11.1957 10.4458 10.7539 10.3697C10.5432 10.3334 10.3198 10.3334 9.87314 10.3334H8.12741C7.68072 10.3334 7.45737 10.3334 7.24664 10.3697C6.80486 10.4458 6.39167 10.6393 6.05036 10.93C5.88756 11.0686 5.74457 11.2402 5.45861 11.5834L5.14597 11.9585C4.68403 12.5128 3.99973 12.8334 3.27816 12.8334C1.86714 12.8334 0.752453 11.6362 0.852984 10.2288L1.05801 7.35837C1.21386 5.17653 1.29178 4.0856 1.76642 3.25885C2.18431 2.53093 2.81231 1.94619 3.56816 1.58121C4.42663 1.16669 5.52033 1.16669 7.70774 1.16669Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgPlayingGameIcon
